<template>
    <div class="container-fluid">
        <div class="row">
            <!-- DB 요청 -->
            <div class="col-md-9 mb-3">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-12">
                                <h6><i class="fas fa-user-plus onmaum-text-dental text-sm opacity-10"></i> DB 요청</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="onmaum-alert onmaum-alert-dental" role="alert">
                                    <ul>
                                        <li>DB 요청 방법 => '연도', '월', '요청건수' 선택 후 '요청' 클릭</li>
                                        <li>같은 '연도', '월'로 재요청 시 요청건수가 수정됩니다.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-md-3 mb-2">
                                <label for="reqYear" class="form-control-label">요청연도 *</label>
                                <select id="reqYear" class="form-control" v-model="reqYear">
                                    <option selected="selected" value="">연도선택</option>
                                    <option v-for="(year, i) in years" :key="i" :value="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-2">
                                <label for="reqMonth" class="form-control-label">요청월 *</label>
                                <select id="reqMonth" class="form-control" v-model="reqMonth">
                                    <option selected="selected" value="">월선택</option>
                                    <option v-for="(month, i) in months" :key="i" :value="month">{{ month }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-2">
                                <label for="reqCount" class="form-control-label">요청건수 *</label>
                                <select id="reqCount" class="form-control" v-model="reqCount">
                                    <option selected="selected" value="">선택</option>
                                    <option v-for="(count, i) in counts" :key="i" :value="count">{{ count }}</option>
                                </select>
                            </div>
                            <button class="col-md-3 btn btn-success m-0 p-0 mb-2" @click="request()">요청</button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- 요청된 DB 건수 확인 -->
            <div class="col-md-3 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h6><i class="fas fa-user-check onmaum-text-success text-sm opacity-10"></i> 요청한 DB 건수</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" v-for="(db, i) in requestDBCount" :key="i">
                                <div class="card p-2 text-center mb-1">
                                    <div class="card-header p-0">
                                        {{ db.year }}/{{ db.month }}
                                    </div>
                                    <div class="card-body p-0">
                                        {{ db.regist }}/{{ db.count }}(건)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>        
    </div>
</template>

<script>
export default {
    name: 'requestDB',
    
    data(){
        return{
            reqYear: '',
            reqMonth: '',
            reqCount: '',
        }
    },

    methods:{
        initPage(){
            this.reqYear = '';
            this.reqMonth = '';
            this.reqCount = '';
        },

        request(){
            console.log(`연도: ${this.reqYear} / 월: ${this.reqMonth} / 건수: ${this.reqCount}`);

            if(this.reqYear && this.reqMonth && this.reqCount) {
                this.$store.dispatch('insertRequestDB',{
                    year: this.reqYear
                    ,month: this.reqMonth
                    ,count: this.reqCount
                });

                this.initPage();
            } else {
                this.$store.commit('setAlert', {  'alertStatus': 'error'
                                                    ,'alertTitle': `DB 할당`
                                                    ,'alertContent': '필숫값을 입력해주세요!'});
            }

            
        }
    },

    computed:{
        years(){
            let result = [];
            let dt = new Date();
            result.push('' + dt.getFullYear());
            result.push('' + (+dt.getFullYear() + 1));

            return result;
        },

        months(){
            return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        },

        counts(){
            let result = Array(30);
            for(let i = 0; i < result.length; i++){
                result[i] = '' + (i + 1);
            }

            return result;
        },

        requestDBCount(){
            return this.$store.getters.getRequestDBCount;
        }
    },

    mounted(){
        this.$store.dispatch('getRequestDB');
    }
}
</script>

<style>

</style>